<template>
  <div class="bookazine_background">
    <nav class="navbar navbar-expand-xl bg-white p-0">
          <div class="container-xl p-0">
              <div class="d-none d-xl-flex align-items-center justify-content-center arrow-container">
                <a href="https://acg.agency">
                  <img src="back.svg" alt="ACG" class="img-fluid">
                </a>
              </div>
              <button class="navbar-toggler collapsed ms-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="icon-bar top-bar"></span>
                  <span class="icon-bar middle-bar"></span>
                  <span class="icon-bar bottom-bar"></span>
              </button>
              <!-- for MOBILE TWENTY text-->
              <a class="text-black text-decoration-none px-3 d-flex align-items-center d-block d-xl-none my-3" href="https://acg.agency">
                  <h1 class="mb-0">TWENTY</h1>
              </a>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav me-auto d-flex align-items-xl-center ">
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" aria-current="page" href="#" id="page8" @click="gotoPage(8)">Contemporaty Fine Art</a>
                      </li>
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" href="#" id="page42" @click="gotoPage(42)" >Performativ</a>
                      </li>
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" href="#" id="page68" @click="gotoPage(68)">Design</a>
                      </li>
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" href="#" id="page100" @click="gotoPage(100)">Music</a>
                      </li>
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" href="#" id="page122" @click="gotoPage(122)">Fashion</a>
                      </li>
                      <li class="nav-item py-xl-3 mx-lg-2 py-0 mx-0 px-3 px-lg-1">
                          <a data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" class="nav-link text-uppercase py-2 px-2" href="#" id="page148" @click="gotoPage(148)">Motion Picture</a>
                      </li>
                      <li class="nav-item py-0 mx-0 d-flex d-xl-none px-3" style="background-color:#FEBED6;border-top:1px solid black;">
                        <a class="nav-link text-uppercase py-1 px-2 back" href="https://acg.agency"><img src="back.svg" alt="ACG" width="20" class="img-fluid me-3">Back</a>
                      </li>
                      <li class="nav-item py-0 mx-0 d-flex d-xl-none px-3 px-lg-1">
                        <a class="nav-link text-uppercase py-2 px-2"  href="/">HU</a>
                      </li>
                  </ul>
              </div>
              <div class="bg-black py-3 px-2 lang-switcher-container align-items-center d-none d-xl-flex">
                  <a class="text-white lang-switcher" href="/">HU</a><span style="margin: 0 5px;height:34px;border-left:1px solid white;"></span><a class="text-white lang-switcher  active-lang" href="/en">EN</a>
              </div>
              <!-- for DESKTOP -->
              <a class="text-black text-decoration-none brand-logo align-items-center justify-content-center d-none d-xl-flex" href="javascript:void(0)">
                  <h1 class="mb-0">TWE<br>NTY</h1>
              </a>
          </div>
      </nav>
   
    

    <flipbook ref="flipbook" :startPage="page" class="flipbook" :zooms="[1, 2]" :pages="pages"></flipbook>
    <div class="left_arrow" @click="gotoLeft()"></div>
    <div class="right_arrow"  @click="gotoRight()"></div>
  </div>
</template>

<style>
body{
  overflow:hidden;
}
.left_arrow{
  
  width: calc((100vw - (100vh - 120px) * 1.514) / 2);
  height: calc(100vh - 120px);
  position:absolute;
  background-image: url("./assets/arrow_left.svg");
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  left: 0px;
  top: 100px;
  z-index: 1000;
  min-width: 20px;
  cursor: pointer;
  transition: 0.5s;
 
}
.left_arrow:hover{
  background-size: 55%;
}
.right_arrow{
 
  width: calc((100vw - (100vh - 120px) * 1.514) / 2);
  height: calc(100vh - 120px);
  position:absolute;
  background-image: url("./assets/arrow_left.svg");
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center center;
  right: 0px;
  top: 100px;
  z-index: 1000;
  transform:scaleX(-1);
  min-width: 20px;
  cursor: pointer;
  transition:0.5s;
 
}
.right_arrow:hover{
  background-size: 55%;
}
.bookazine_background {
  background-color: #e5e5e5;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  position: relative;
  overflow: hidden;

}

.flipbook {
  position: relative;
  top: 10px;
  width: calc((100vh - 120px) * 1.514);
  height: calc(100vh - 120px);
  max-width: calc(100vw - 40px);
  margin-right: auto;
  margin-left: auto;
}
</style>


<script>
import Flipbook from 'flipbook-vue'
export default {
  components: { Flipbook },
  data() {
    return {
      pages: [null],
      page: 1
    }
  },
  methods: {
    gotoLeft() {
      if (this.$refs.flipbook.canFlipLeft)
      {
        this.$refs.flipbook.flipLeft();
      } 
    },
    gotoRight() {
      if (this.$refs.flipbook.canFlipRight)
      {
        this.$refs.flipbook.flipRight();
      } 
    },
    gotoPage(page) {
      this.page = page;
      var list = document.getElementsByClassName('nav-link')
      for(var i  =0;i  < list.length;i++){
        
        var element = list[i];
        element.classList.remove('active'); 
      };
      document.getElementById('page'+page).classList.add('active');
    },
    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
   

  },
  mounted() {
   
    this.pages = [null]
    for (var i = 1; i <= 157; i++) {

      this.pages.push('https://bookazine.acg.agency/en/' + this.pad(i, 3, '0') + '.jpg');
    }
  }
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
